import { Injectable, Provider, Signal } from '@angular/core';
import { GeoCoordinates } from '@fmnts/common/geolocation';
import { Option } from 'effect';
import { Observable } from 'rxjs';

@Injectable()
export abstract class DeclarativeGeolocationService {
  /** Current coordinates. */
  abstract readonly coordinates: Signal<Option.Option<GeoCoordinates>>;

  /** `true` if the accuracy of the coordinates can be improved. */
  abstract readonly canImproveAccuracy: Signal<boolean>;

  /** Emits with the most recent coordinates. */
  abstract readonly latestCoordinates$: Observable<GeoCoordinates>;

  /** Updates the current position. */
  abstract updatePosition(): void;
}

export function provideDeclarativeFormsGeolocationFeature(config: {
  geolocation: () => DeclarativeGeolocationService;
}): Provider {
  return [
    {
      provide: DeclarativeGeolocationService,
      useFactory: config.geolocation,
    },
  ];
}
